// @flow
import React from 'react';
import { useParams } from 'react-router-dom';
import { useStripe } from '@stripe/react-stripe-js';
import { useDispatch } from 'react-redux';
import SwitchCheckbox from '../../components/SwitchCheckbox/SwitchCheckbox';
import handlerPayments from './handlerPayments';
import { ReactComponent as PayPal } from '../../assets/icons/PayPal-logo.svg';
import { ReactComponent as Mastercard } from '../../assets/icons/Mastercard_2019_logo 1.svg';
import { ReactComponent as Visa } from '../../assets/icons/visa.svg';

import styles from './styles.module.scss';

const ITEMS = [
  {
    name: 'Card payments',
    paymentName: 'stripe',
    Icon: (
      <div className={styles.cardPaymentsWrapper}>
        <Visa className={styles.cardPayments} />
        <Mastercard />
      </div>
    ),
  },
  {
    name: 'PayPal',
    paymentName: 'paypal',
    Icon: <PayPal />,
  },
];

const Payments = () => {
  const { type } = useParams();
  const stripe = useStripe();
  const dispatch = useDispatch();
  const [checkedPayment, setCheckedPayment] = React.useState({
    stripe: true,
    paypal: false,
  });

  const handleChecked = (paymentName, cb, obj) => {
    let subObj = {};
    Object.keys(obj).map((checked: string) => {
      subObj = { ...subObj, [checked]: false };
      return null;
    });
    cb({ ...subObj, [`${paymentName}`]: true });
  };

  return (
    <>
      <div className={styles.payments}>
        <div className={styles.paymentsList}>
          <div className={styles.blockTop}>
            <div className={styles.title}>
              OMAHA
              <span className={styles.titleRed}>PRO</span>
            </div>
            <div className={styles.subTitle}>Please select payment method:</div>
            <SwitchCheckbox
              checked={checkedPayment}
              handleCheckbox={handleChecked}
              items={ITEMS}
              setCheckedItems={setCheckedPayment}
            />
          </div>
          <div className={styles.buttonWrapper}>
            {handlerPayments(type, checkedPayment, stripe, dispatch)}
          </div>
        </div>
      </div>
    </>
  );
};

export default Payments;
